namespace NKU.VideoCustom {
	let setupVideoControls = () => {
		let mp4Player = document.querySelectorAll('.js-custom-video-player');

		//For Each Video player, setup our play/pause events
		mp4Player.forEach((player: HTMLDivElement) => {
			let video = player.querySelector('video');
			let playButton = player.querySelector('.js-video-play');
			let pauseButton = player.querySelector('.js-video-pause');

			let togglePlay = () => {
				playButton.classList.toggle('visually-hidden');
				pauseButton.classList.toggle('visually-hidden');
			};

			playButton.addEventListener('click', () => {
				togglePlay();
				void video.play();
			});

			pauseButton.addEventListener('click', () => {
				togglePlay();
				video.pause();
			});
		});
	};
	export const init = () => {
		setupVideoControls();
	};
}

document.addEventListener('DOMContentLoaded', () => {
	NKU.VideoCustom.init();
});
